import { useState, type FormEvent } from "react";
import { Button } from "../ui/Button";
import "./ContactForm.css";
import { wordpressContactConfig } from "../../wordpress";

export function ContactForm() {
	const [status, setStatus] = useState<"idle" | "sending" | "success" | "error">("idle");
	const [feedback, setFeedback] = useState("");

	const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		const element = event.currentTarget;
		const form = new FormData(element);
		const name = String(form.get("name") ?? "");
		const email = String(form.get("email") ?? "");
		const message = String(form.get("message") ?? "");
		const wpConfig = wordpressContactConfig();

		if (wpConfig) {
			setStatus("sending");
			setFeedback("Enviant el missatge…");
			form.set("action", "cosanova_contact_submit");
			form.set("nonce", wpConfig.contactNonce);

			try {
				const response = await fetch(wpConfig.ajaxUrl, {
					method: "POST",
					body: form,
					credentials: "same-origin",
				});
				const result = await response.json();

				if (!response.ok || !result.success) {
					throw new Error(result.data?.message || "No s’ha pogut enviar el missatge.");
				}

				setStatus("success");
				setFeedback(result.data?.message || "Missatge enviat. Gràcies!");
				element.reset();
			} catch (error) {
				setStatus("error");
				setFeedback(
					error instanceof Error
						? error.message
						: "No s’ha pogut enviar el missatge. Torna-ho a provar.",
				);
			}

			return;
		}

		const subject = encodeURIComponent(`Contacte web · ${name}`);
		const body = encodeURIComponent(
			`Nom: ${name}\nAdreça de correu electrònic: ${email}\n\nMissatge:\n${message}`,
		);

		window.location.href = `mailto:info@cosanova.cat?subject=${subject}&body=${body}`;
	};

	return (
		<form className="contact-form" onSubmit={handleSubmit}>
			<div className="contact-form__website" aria-hidden="true">
				<label htmlFor="contact-website">Lloc web</label>
				<input id="contact-website" name="website" type="text" tabIndex={-1} autoComplete="off" />
			</div>
			<div className="contact-form__field">
				<label htmlFor="contact-name">Nom</label>
				<input id="contact-name" name="name" type="text" autoComplete="name" required />
			</div>

			<div className="contact-form__field">
				<label htmlFor="contact-email">Adreça de correu electrònic</label>
				<input id="contact-email" name="email" type="email" autoComplete="email" required />
			</div>

			<div className="contact-form__field contact-form__field--message">
				<label htmlFor="contact-message">Missatge</label>
				<textarea id="contact-message" name="message" rows={8} required />
			</div>

			<Button type="submit" variant="ink" disabled={status === "sending"}>
				{status === "sending" ? "Enviant…" : "Enviar"}
			</Button>
			{feedback && (
				<p
					className={`contact-form__status contact-form__status--${status}`}
					role={status === "error" ? "alert" : "status"}
				>
					{feedback}
				</p>
			)}
		</form>
	);
}
